import React from "react";
import {NavLink, useLocation} from "react-router-dom";
import Tooltip from "components/tooltips/Tooltips";
import UseContext from "hooks/useContext";
import { ORANGE_COLORS } from "utils/colors";

/** gray-700 (Tailwind) — pour forcer une couleur d’icône fixe (ex. sous-liens vivier) */
const GRAY_700 = '#374151';

const SidebarUnitDesktop = ({routeSidebar, routeName, icon: IconComponent, text, exactMatch = false, children, isSubItem = false, activePatterns = [], expandOnly = false, onExpandClick, iconColor}) => {
    const {sidebarExpanded} = UseContext()
    const location = useLocation()
    const pathname = location.pathname
    
    // Détermine si l'item est actif (exact match ou includes selon le prop)
    // Pour les routes timeSheet, on vérifie si on est sur n'importe quelle page de timeSheet
    // activePatterns permet de spécifier des patterns additionnels qui activent cet élément
    const matchesActivePatterns = activePatterns.length > 0 && activePatterns.some(pattern => pathname.includes(pattern));
    const isActive = exactMatch 
        ? pathname === routeSidebar 
        : routeSidebar?.startsWith('/timeSheet/')
            ? pathname.startsWith('/timeSheet/')
            : routeSidebar ? (pathname.includes(routeSidebar) || pathname === routeSidebar || matchesActivePatterns) : matchesActivePatterns

    /** Rail 80px (tab → 2xl) : centrer l’icône quand la sidebar n’est pas étendue */
    const collapsedRail = !sidebarExpanded
    const rowCollapsedCenter =
        collapsedRail ? 'tab:max-2xl:justify-center' : ''
    const labelCollapsedHidden =
        collapsedRail ? 'tab:max-2xl:hidden' : ''

    const contentClasses = isSubItem && isActive
        ? 'flex items-center h-[44px] rounded-lg border border-gray-100 px-2 py-3 transition duration-150 hover:bg-gray-100 text-gray-700 bg-gray-100'
        : `flex items-center h-[44px] rounded-lg border px-2 py-3 transition duration-150 ${
            isActive 
                ? 'border-yellow-100 text-yellow-600 bg-yellow-50 hover:border-yellow-200' 
                : 'border-[#FCFCFC] text-gray-700 bg-transparent hover:bg-gray-100 hover:border-gray-100'
        }`

    const trailingSlotClass =
        children && (IconComponent || text)
            ? expandOnly
                ? collapsedRail
                    ? 'shrink-0 tab:max-2xl:ml-1'
                    : 'ml-auto'
                : collapsedRail
                  ? 'ml-auto tab:max-2xl:hidden'
                  : 'ml-auto'
            : ''

    const content = (
        <div
            id={routeName}
            className={`flex items-center w-full ${rowCollapsedCenter}`}
        >
            {IconComponent && (
                <span className='shrink-0'>
                    <IconComponent
                      wh={24}
                      color={
                        iconColor ??
                        (isActive ? ORANGE_COLORS[600] : GRAY_700)
                      }
                    />
                </span>
            )}
            {text && (
                <span
                    className={`ft-sm font-medium ${IconComponent ? 'ml-4' : ''} ls:opacity-0 ls:sidebar-expanded:opacity-100 2xl:opacity-100 duration-200 ${labelCollapsedHidden}`}
                >
                    {text}
                </span>
            )}
            {!IconComponent && !text && children}
            {children && (IconComponent || text) && (
                <div className={trailingSlotClass}>
                    {children}
                </div>
            )}
        </div>
    )

    return (
        <>
            <li>
                <Tooltip
                    text={text || routeName}
                    disabled={sidebarExpanded}
                    placement="right"
                >
                    {expandOnly ? (
                        <button
                            type="button"
                            onClick={onExpandClick}
                            className={`w-full text-left cursor-pointer ${contentClasses}`}
                        >
                            {content}
                        </button>
                    ) : (
                    <NavLink
                        end={exactMatch}
                        to={routeSidebar}
                        className={({isActive: navIsActive}) => {
                            const active = exactMatch ? navIsActive : (navIsActive || isActive)
                            if (isSubItem && active) {
                                return `flex items-center h-[44px] rounded-lg border border-gray-100 px-2 py-3 transition duration-150 hover:bg-gray-100 text-gray-700 bg-gray-100`
                            }
                            return `flex items-center h-[44px] rounded-lg border px-2 py-3 transition duration-150 ${
                                active 
                                    ? 'border-yellow-100 text-yellow-600 bg-yellow-50 hover:border-yellow-200' 
                                    : 'border-[#FCFCFC] text-gray-700 bg-transparent hover:bg-gray-100 hover:border-gray-100'
                            }`
                        }}
                        style={({isActive: navIsActive}) => {
                            const active = exactMatch ? navIsActive : (navIsActive || isActive)
                            if (isSubItem && active) {
                                return { backgroundColor: '#F3F4F6' }
                            }
                            return {}
                        }}
                    >
                        {content}
                    </NavLink>
                    )}
                </Tooltip>
            </li>
        </>
    );
};

export default SidebarUnitDesktop;
